export default __webpack_public_path__ + "static/media/leipzig.5fcb014e.jpg";